import { Observable } from "rxjs";
import { ListarComunicadosInputDto } from "../domain/DTOs/input/listar-comunicados.input.dto";
import { BaseService } from "./base.service";
import { ComunicadoOutputDto } from "../domain/DTOs/output/comunicado.output.dto";
import { EstruturaRetornoDadosPaginadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados-paginados.output.dto";
import { Injectable } from "@angular/core";

@Injectable()
export class ComunicadosService {

  constructor(private readonly baseService: BaseService) {}

  public listarComunicados(
    listarComunicadoInputDto: ListarComunicadosInputDto
  ): Observable<EstruturaRetornoDadosPaginadosOutputDto<ComunicadoOutputDto[]>> {
    return this.baseService.getFiltered(
      `Comunicado/ListarComunicados`
      , `TextoPesquisa=${listarComunicadoInputDto.TextoPesquisa}`
      ,listarComunicadoInputDto
    );
  }
}
